import { useEffect, useState } from 'react';

import { useIntlContext } from '../../../data/context/intl-context';
import { getRelativeTime } from '../../../data/utils/date.utils';

type RelativeTimeProps = {
  value: Date | string;
};

export function RelativeTime({ value }: RelativeTimeProps) {
  const { language } = useIntlContext();

  const [time, setTime] = useState<string>(
    getRelativeTime(value, language) ?? ''
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getRelativeTime(value, language) ?? '');
    }, 1000);

    return () => clearInterval(interval);
  }, [value, language]);

  return time;
}
